import React from 'react';
import {Col, Container, Row, Card, CardBody, Button} from 'reactstrap';
import {connect} from 'react-redux';
import LoadingProgress from '../../components/LoadingProgress'
import ReactQueryParams from 'react-query-params';
import {ButtonToolbar} from 'reactstrap';
import {fetchTasksDataIfNeeded} from '../../redux/actions/TasksActions';
import {fetchUtilsDataIfNeeded} from '../../redux/actions/UtilsActions'
import {withRouter} from 'react-router-dom';
import Alert from '../../components/Alert';
import TasksTable from './components/TasksTable'
import * as TextManager from "../../modules/languages/TextManager";


export class Tasks extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: ''
        };
    }

    componentDidMount() {
        this.props.dispatch(fetchTasksDataIfNeeded(this.queryParams));
        this.props.dispatch(fetchUtilsDataIfNeeded());
    }

    render() {

        /*let isManager = false;
        let isAdmin = false;
        if(this.props.userData && this.props.userData.data && this.props.userData.data.userType){
            isManager = this.props.userData.data.isManager;
            isAdmin = this.props.userData.data.isAdmin;
        }*/

        let data = this.props.data;

        //console.log(data);

        return (
            <Container className='dashboard'>

                { this.props.status === 'request' &&
                <Row>
                    <LoadingProgress/>
                </Row>
                }

                { this.props.status === 'error' &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>
                }

                { this.props.status === 'no_permission' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.loginFailed}</span>
                            {TextManager.getCurrentTextResource().Text.pleaseRefreshThePage}</p>
                    </Alert>
                </Row>
                }

                { this.props.status === 'success' &&
                <span>
                    <Row>
                      <Col md={3} md={12}>
                        <Card>
                            <CardBody style={{padding: "1.25rem"}}>
                                <h3 style={{textAlign: 'right'}}>משימות</h3>
                                <div style={{display: 'flex', height: '100%', width: '70%'}}>
                                </div>
                            </CardBody>
                        </Card>
                        </Col>
                    </Row>
                    <Row>
                        <TasksTable data={data}/>
                    </Row>
                </span>
                }

            </Container>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        status: state.tasks.status,
        data: state.tasks.data,
        userData:state.userData,
        utilsData:state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(Tasks))